<template>
  <div class="bigbox">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="录入员工：">
        <div clearable @click="chooseuser" size="small" class="input" style="
            border: 1px solid #e5e5e5;
            height: 32px;
            border-radius: 5px;
            line-height: 32px;
            color: #dcdfe6;
          ">
          <div v-if="!istrue" style="margin-left: 15px; color: #dcdfe6">
            {{
              form.inputPersonProvince +
              form.inputPersonCompanyName +
              form.inputPerson
            }}
          </div>

          <div v-else style="margin-left: 15px">
            <div v-if="form.inputPerson" style="color: #606266">
              {{
                form.inputPersonProvince +
                form.inputPersonCompanyName +
                form.inputPerson
              }}
            </div>
            <div v-else style="color: #dcdfe6">请选择</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="签单员工：">
        <div clearable @click="chooseuser1" size="small" class="input" style="
            border: 1px solid #e5e5e5;
            height: 32px;
            border-radius: 5px;
            line-height: 32px;
            color: #dcdfe6;
          ">
          <div v-if="signingStaff" style="margin-left: 15px; color: #606266">
            {{ signingStaff }}
          </div>
          <div v-else style="margin-left: 15px; color: #dcdfe6">请选择</div>
        </div>
      </el-form-item>
      <el-form-item label="销售产品：" prop="productType">
        <el-select clearable @change="productChange" v-model="product" placeholder="请选择" size="small" class="input"
                   value-key="productId">
          <el-option v-for="item in options" :key="item.productId" :label="item.productName" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品类型：" prop="productType">
        <el-select clearable v-model="form.productType" placeholder="请选择" @change="getShoppProductPage" size="small"
                   class="input">
          <el-option v-for="item in optionstype" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="咨询专家：" v-if="form.productType == 2 || containOneToOneProduct" prop="productType">
        <el-input clearable v-model="form.expertName" size="small" class="input" placeholder="请选择专家"></el-input>
        <el-button type="text" style="font-size: 14px" @click="dialogVisible = true">选择</el-button>
      </el-form-item>
      <el-form-item label="订单日期：">
        <el-date-picker :picker-options="pickerOptions" v-model="orderDateTime" type="datetime"
                        placeholder="选择日期时间"
                        clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="产品价格：">
        {{ product.marketPrice ? product.marketPrice / 100 : 0 }}元
      </el-form-item>
      <el-form-item label="销售数量：" prop="num" :rules="rules">
        <el-input clearable v-model="form.num" size="small" class="input" type="number" placeholder="请输入销售数量">
        </el-input>
      </el-form-item>
      <el-form-item label="订单金额：" prop="orderPrice" :rules="rules">
        <el-input clearable v-model="orderPrice" size="small" class="input" @input="numContro($event, 1)"
                  placeholder="请输入订单金额(单位元)"></el-input>
      </el-form-item>
      <el-form-item label="实付金额：" prop="orderPrice" :rules="rules">
        <el-input clearable v-model="paidPrice" size="small" class="input" @input="numContro($event, 2)"
                  placeholder="请输入实付金额(单位元)"></el-input>
      </el-form-item>
      <el-form-item label="支付方式：">
        <el-select v-model="form.paymentMethod" placeholder="请选择" size="small" class="input">
          <el-option v-for="item in optionspaymentMethod" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-row>
        <el-col :span="7">
          <el-form-item label="学生姓名：" prop="userName">
            <el-input
              clearable
              v-model="form.userName"
              size="small"
              style="width: 150px"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="服务电话：" prop="contactPhone">
            <el-input
              clearable
              v-model="form.contactPhone"
              size="small"
              style="width: 200px; margibn-right: 20px"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9" v-if="form.productType != 1">
          <el-form-item label="身份证号码：">
            <el-input
              clearable
              v-model="form.identityNumber"
              size="small"
              style="width: 200px; margibn-right: 20px"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->

      <el-row>
        <el-col :span="5">
          <el-form-item label="签约人：" prop="signName">
            <el-input clearable v-model="form.signName" size="small" style="width: 130px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="关系：" prop="fatherShip">
            <el-select v-model="form.signShip" placeholder="请选择关系" size="small" style="width: 130px">
              <el-option v-for="item in shipoptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="身份证号码：" prop="signIdCard">
            <el-input clearable v-model="form.signIdCard" size="small" style="width: 180px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="签约人电话：">
            <el-input clearable v-model="form.signPhone" size="small" style="width: 130px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item label="学生姓名：" prop="userName">
            <el-input clearable v-model="form.userName" size="small" style="width: 130px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="服务电话：" prop="contactPhone">
            <el-input clearable v-model="form.contactPhone" size="small" style="width: 130px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="推荐备注:">
            <el-input style="width: 500px" clearable type="textarea" v-model="form.recommendInfo"
                      placeholder="请输入内容"
                      :rows="5"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer">
      <el-button size="small" class="button" @click="goback">返回</el-button>
      <el-button type="primary" size="small" @click="saveShoppOrder" v-if="calcjain(orderPrice, paidPrice, 2) == 0">下一步
      </el-button>
      <el-button type="primary" size="small" @click="placeOrder" v-else>确定</el-button>
    </div>
    <!-- 签单人员 -->
    <el-dialog title="选择签单人员" :visible.sync="centerDialogVisible" width="50%" center @close="close">
      <span>
        <el-form :inline="true">
          <el-form-item label="所属省份：">
            <el-select :disabled="disabled4" @change="changeprovince" v-model="province" placeholder="请选择所属省份"
                       size="small" class="input" value-key="id">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属公司：" prop="productType">
            <el-select @change="pageuser(4)" v-model="form.company" placeholder="请选择所属公司" size="small"
                       class="input"
                       value-key="companyId">
              <el-option v-for="item in companyoptions" :key="item.companyId" :label="item.companyName" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="签单人员：">
            <el-input size="small" placeholder="姓名或联系方式" v-model="formInline.keyWord"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="pageuser(4)">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" size="mini" :data="gridData" border
                  maxHeight="350"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column property="realName" label="姓名" width="120">
          </el-table-column>
          <el-table-column property="six" label="性别" width="80">
          </el-table-column>
          <el-table-column property="phoneNum" label="联系电话">
          </el-table-column>
          <el-table-column property="departmentName" label="所属公司">
          </el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="text" style="font-size: 14px" @click="surechoose(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </span>
    </el-dialog>
    <!--录入人员 -->
    <el-dialog title="选择录入人员" :visible.sync="centerDialogVisible1" width="50%" center @close="closeinput">
      <span>
        <el-form :inline="true">
          <el-form-item label="所属省份：">
            <el-select @change="changeprovince" v-model="inputprovince" placeholder="请选择所属省份" size="small"
                       class="input"
                       value-key="id">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属公司：" prop="productType">
            <el-select @change="pageuser(5)" v-model="form.inputPersonCompany" placeholder="请选择所属公司" size="small"
                       class="input" value-key="companyId">
              <el-option v-for="item in companyoptions" :key="item.companyId" :label="item.companyName" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="formInline1" class="demo-form-inline">
          <el-form-item label="录入员工：">
            <el-input size="small" placeholder="姓名或联系方式" v-model="formInline1.keyWord"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="pageuser(5)">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" size="mini" :data="gridData" border
                  maxHeight="350"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column property="realName" label="姓名" width="120">
          </el-table-column>
          <el-table-column property="six" label="性别" width="80">
          </el-table-column>
          <el-table-column property="phoneNum" label="联系电话">
          </el-table-column>
          <el-table-column property="departmentName" label="所属公司">
          </el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="text" style="font-size: 14px" @click="chooseinput(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </span>
    </el-dialog>
    <!-- 选择专家 -->
    <el-dialog title="选择专家" :visible.sync="dialogVisible" width="80%">
      <span>
        <el-form :inline="true" :model="formInzj" class="demo-form-inline">
          <el-form-item label="所在省份：">
            <el-select disabled v-model="provinceobj" placeholder="" class="el-select1" size="small" value-key="id">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专家：">
            <el-input size="small" placeholder="姓名或联系方式" v-model="formInzj.keyWord"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getRelatedExperts">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" size="mini" height="500" :data="zjdata" border
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }" style="100%">
          <el-table-column type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column property="expertName" label="专家姓名" width="120">
          </el-table-column>
          <el-table-column property="identityPhoto" label="证件照" width="120">
          </el-table-column>
          <el-table-column property="sex" label="性别" width="80">
          </el-table-column>
          <el-table-column property="contactPhone" label="联系电话" width="140">
          </el-table-column>
          <el-table-column property="email" label="邮箱地址"> </el-table-column>
          <el-table-column property="province" label="所在省份" width="120">
          </el-table-column>
          <el-table-column property="type" label="专家组别" width="120">
          </el-table-column>
          <el-table-column property="address" label="详细地址">
          </el-table-column>
          <el-table-column label="服务价格" width="120">
            <template slot-scope="scope">
              {{ scope.row.servicePrice / 100 }}
            </template>
          </el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="text" style="font-size: 14px" @click="surezj(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {Decimal} from "decimal.js"; //引入
import {
  getCompanyList,
  getRelatedExperts,
  getShoppProductPage,
  pageuser,
  placeOrder,
} from "@/api/commodityManagement.js";
import rules from "@/util/rules.js";
import {getProvinceList} from "@/api/index.js";
import {isflag} from "@/util/isflag.js";
import {getUUID} from "@/util/UUIDUitls.js";

export default {
  data() {
    return {
      signingStaff: "", //签单员工
      disabled1: true,
      pickerOptions: {
        disabledDate(time) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return time.getTime() > Date.now(); //选当前时间之前的时间
          //return time.getTime() < Date.now()//选当前时间之后的时间
        },
      },
      optionspaymentMethod: [
        {label: "现金", value: 1},
        {label: "刷卡", value: 2},
        {label: "转账", value: 3},
        {label: "微信支付", value: 4},
        {label: "支付宝支付", value: 5},
        // { label: "线上小程序", value: 6 },
        {label: "组合支付", value: 7},
      ],
      inputprovince: {}, //录入省份
      count: 0,
      orderPrice: "",
      paidPrice: "",
      rulesUtils: rules,
      orderDateTime: new Date(),
      form: {
        company: {},
        inputPersonCompany: {},
        orderTime: new Date(),
        num: 1,
        shopUUID: ""
      },
      options: [],
      provinceobj: {}, //筛选专家省份
      product: {
        marketPrice: 0,
      }, //商品
      dialogVisible: false,
      zjdata: [],
      formInzj: {},
      optionstype: [
        {label: "实体类", value: 1},
        {label: "1对1服务", value: 2},
        {label: "数据查询类", value: 3},
        {label: "测评类", value: 4},
        {label: "智能填报类", value: 5},
      ],
      shipoptions: [
        {label: "父子", value: "1"},
        {label: "父女", value: "2"},
        {label: " 母子", value: "3"},
        {label: "母女", value: "4"},
        {label: "其他", value: "5"},
      ], //关系
      formInline1: {},
      province: {},
      companyoptions: [],
      centerDialogVisible: false,
      centerDialogVisible1: false,
      formInline: {},
      istrue: 0, //控制录入员工选择
      data: [],
      options1: [],
      gridData: [],
      disabled: true,
      defaultProps: {
        children: "list",
        label: "companyName",
      },
      user: {},
      disabled4: true,
      xxooxx: "",
      rules: {},
      //判断关联产品，新增订单当前步骤只需判断是否包含1对1服务产品，需要选择专家
      containOneToOneProduct: false,
    };
  },
  watch: {
    $route(val) {
      if (val.path == "/newOrder") {
        this.signingStaff = "";
        this.count = 0;
        this.provinceobj = {};
        this.keyWord = {};
        this.formInline1 = {};
        this.inputprovince = {};
        this.formInline = {};
        this.province = {};
        this.form = {
          company: {},
          orderTime: new Date(),
          inputPersonCompany: {},
        };
        this.form.shopUUID = getUUID();
        this.paidPrice = "";
        this.orderPrice = "";
        this.product = {
          marketPrice: 0,
        }; //商品
        let sysUser = window.sessionStorage.getItem("sysUser");
        this.user = JSON.parse(sysUser);
        this.form.repeatSubmissionuuid = this.guid();
        this.getShoppProductPage();
        this.getProvinceList();
      }
    },
  },
  mounted() {
    let sysUser = window.sessionStorage.getItem("sysUser");
    this.user = JSON.parse(sysUser);
    this.form.shopUUID = getUUID();
    this.getShoppProductPage();
    this.getProvinceList();
  },
  methods: {
    calcjain(a, b, c) {
      if (a && b && c) {
        return new Decimal(a).sub(new Decimal(b)).toNumber().toFixed(c);
      }
    },
    // 待付款金额限制
    numContro(value, type) {
      if (!value) return;
      let val = (value && value.split("")) || [];
      let sNum = val.toString();
      if (sNum.indexOf(".") === 0) {
        sNum = "0" + sNum; //若第一位直接写 . 的情况下，给首位拼接一个0
      }
      sNum = sNum.replace(/[^\d.]/g, ""); // 过滤
      sNum = sNum.replace(/\.{2,}/g, "."); //只留第一个小数点，清除多余的
      sNum = sNum.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      sNum = sNum.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      if (sNum.indexOf(".") < 0 && sNum !== "") {
        sNum = parseFloat(sNum); // 控制首位不能为0
      }
      //此处将值重新赋给绑定的变量
      if (type == 1) {
        this.orderPrice = sNum;
      }
      if (type == 2) {
        this.paidPrice = sNum;
      }
    },
    //生成uuid
    guid() {
      return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        let r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    goback() {
      this.$router.go(-1);
    },
    productChange(product) {
      let productTypeArr = [];
      productTypeArr.push(product.productType);

      if (product.shoppProducts) {
        product.shoppProducts.forEach((item) => {
          productTypeArr.push(item.productType);
        });
      }
      if (productTypeArr.includes(2)) {
        //产品类型同时包含实体类和非实体类
        this.containOneToOneProduct = true;
      } else {
        this.containOneToOneProduct = false;
      }

      this.getRelatedExperts();
    },
    //获取专家
    getRelatedExperts() {
      this.form.productType = this.product.productType;
      this.formInzj.province = this.provinceobj.name;
      this.formInzj.provinceId = this.provinceobj.id;
      this.formInzj.productId = this.product.productId;
      if (this.formInzj.productId) {
        getRelatedExperts(this.formInzj).then((res) => {
          this.zjdata = res.data || [];
        });
      }
    },
    //选择专家
    surezj(data) {
      this.form.expertId = data.expertId;
      this.form.expertName = data.expertName;
      this.form.expertPrice = data.servicePrice;
      this.formInzj.keyWord = "";
      this.dialogVisible = false;
    },

    /**
     * 验证信息
     */
    verify() {
      let reg_tel =
          /^1((3[0-9])|(4[01456879])|(5[0-9])|(6[2567])|(7[0-9])|(8[0-9])|(9[0-9]))\d{8}$/;
      if (!this.form.inputPerson) {
        this.$message.error("请选择录入员工");
        return false;
      }
      if (!this.form.salesman) {
        this.$message.error("请选择签单员工");
        return false;
      }
      if (!this.product.productName) {
        this.$message.error("请选择销售产品");
        return false;
      }
      if (!this.form.productType) {
        this.$message.error("请选择销售产品类型");
        return false;
      }
      if (
          (this.form.productType == 2 || this.containOneToOneProduct) &&
          !this.form.expertId
      ) {
        this.$message.error("请选择咨询专家");
        return false;
      }
      if (!this.orderDateTime) {
        this.$message.error("请选择订单日期");
        return false;
      }
      if (!this.form.num) {
        this.$message.error("请输入销售数量");
        return false;
      }
      if (this.form.num && this.form.num < 1) {
        this.$message.error("销售数量不合法");
        return false;
      }
      if (!this.orderPrice) {
        this.$message.error("请输入订单金额");
        return false;
      }
      if (!isflag(this.paidPrice)) {
        this.$message.error("请输入实付金额");
        return false;
      }
      if (!isflag(this.form.paymentMethod)) {
        this.$message.error("请选择支付方式");
        return false;
      }
      if (!this.form.signName) {
        this.$message.error("请输入签约人姓名");
        return false;
      }
      if (!this.form.signShip) {
        this.$message.error("请选择签约人关系");
        return false;
      }
      if (!this.form.signPhone) {
        this.$message.error("请输入签约人电话");
        return false;
      }
      if (this.form.signPhone && !reg_tel.test(this.form.signPhone)) {
        this.$message.error("签约人电话格式错误");
        return false;
      }
      if (!this.form.userName) {
        this.$message.error("请输入学生姓名");
        return false;
      }
      if (!this.form.contactPhone) {
        this.$message.error("请输入服务电话");
        return false;
      }
      if (this.form.contactPhone && !reg_tel.test(this.form.contactPhone)) {
        this.$message.error("服务电话格式错误");
        return false;
      }
      return true;
    },

    /**
     * 确定
     */
    placeOrder() {
      if (this.verify()) {
        this.form.companyId = this.form.company.companyId;
        this.form.productId = this.product.productId;
        this.form.productName = this.product.productName;
        this.form.provinceId = this.province.id;
        this.form.province = this.province.name;
        this.form.paidPrice = this.paidPrice * 100;
        this.form.orderPrice = this.orderPrice * 100;
        if (this.orderDateTime && typeof this.orderDateTime != String) {
          let time =
              this.orderDateTime.getFullYear() +
              "-" +
              (this.orderDateTime.getMonth() + 1) +
              "-" +
              this.orderDateTime.getDate() +
              " " +
              this.orderDateTime.getHours() +
              ":" +
              this.orderDateTime.getMinutes() +
              ":" +
              this.orderDateTime.getSeconds();
          this.form.orderTime = time;
        }
        this.form.paymentTime = this.form.orderTime;
        placeOrder(this.form).then((res) => {
          if (res.code == 1) {
            this.$router.push("/2.2");
          }
        });
      }
    },
    /**
     * 下一步
     */
    saveShoppOrder() {
      if (this.verify()) {
        this.form.companyId = this.form.company.companyId;
        this.form.productId = this.product.productId;
        this.form.productName = this.product.productName;
        this.form.provinceId = this.province.id;
        this.form.province = this.province.name;
        this.form.paidPrice = this.paidPrice * 100;
        this.form.orderPrice = this.orderPrice * 100;
        let time =
            this.orderDateTime.getFullYear() +
            "-" +
            (this.orderDateTime.getMonth() + 1) +
            "-" +
            this.orderDateTime.getDate() +
            " " +
            this.orderDateTime.getHours() +
            ":" +
            this.orderDateTime.getMinutes() +
            ":" +
            this.orderDateTime.getSeconds();
        this.form.orderTime = time;
        this.form.paymentTime = this.form.orderTime;
        placeOrder(this.form).then((res) => {
          let data = res.data || {};
          if (res.code == 1) {
            let id = data.orderId;
            this.$router.push({path: "/newOrderlast", query: {id: id}});
          }
        });

      }
    },
    changeprovince(val) {
      if (this.province) {
        this.provinceobj = this.province;
      }
      if (this.inputprovince) {
        this.provinceobj = this.inputprovince;
      }
      this.getCompanyList();
      this.getRelatedExperts();
      this.form.inputPersonCompany = {};
      this.form.company = {};
    },
    closeinput() {
      // this.changeprovince ={}
      // this.form.inputPersonCompany = {}
      // this.formInline1.keyWord = ""
      this.gridData = [];
    },
    //查询所有省份
    getProvinceList() {
      let id = "";
      if (this.user.provincePrerm.includes(",")) {
        let arr = this.user.provincePrerm.split(",");
        if (arr[0] !== "") {
          id = arr[0];
        } else {
          id = arr[1];
        }
      } else {
        id = this.user.provincePrerm;
      }

      getProvinceList({}).then((res) => {
        let data = res.data || [];
        this.options1 = data;
        if (id != "0") {
          let obj = data.filter((item) => {
            return item.id == id;
          });
          this.provinceobj.id = id;
          this.provinceobj.name = obj[0].name;
        }

        //判断获取录入员工
        if (this.user.sysUserRole == 0 || id == "0") {
          this.istrue = 1;
          this.disabled4 = false;
        } else {
          this.form.inputPersonProvinceId = id;

          let obj = this.options1.filter((item) => {
            return item.id == this.form.inputPersonProvinceId;
          });
          this.form.inputPersonProvince = obj[0].name;

          if (this.user.sysUserRole == 0 || this.user.province == "0") {
            this.disabled1 = false;
            this.disabled = false;
          } else {
            this.user.provinceId = id;
            let obj = this.options1.filter((item) => {
              return item.id == this.user.provinceId;
            });
            this.user.province = obj[0].name;
            this.province = {
              name: this.user.province,
              id: this.user.provinceId,
            };
            this.signingStaff =
                this.user.province +
                this.user.departmentName +
                this.user.realName;
            this.form.salesman = this.user.realName;
          }
          this.form.repeatSubmissionuuid = this.guid();
          this.form.inputPersonCompanyName = this.user.departmentName;
          this.form.inputPersonCompanyId = this.user.departmentId;
          this.form.inputPerson = this.user.realName;
        }
        this.getCompanyList();
      });
    },
    close() {
      // this.province = {}
      // this.form.company = {}
      this.formInline.keyWord = "";
      this.gridData = [];
    },
    //选择录入人员
    chooseinput(data) {
      this.form.inputPersonProvince = this.inputprovince.name
          ? this.inputprovince.name
          : "";
      this.form.inputPersonProvinceId = this.inputprovince.id
          ? this.inputprovince.id
          : "";
      this.form.inputPersonCompanyName =
          this.form.inputPersonCompany.companyName;
      this.form.inputPersonCompanyId = this.form.inputPersonCompany.companyId;
      this.form.inputPerson = data.realName;
      this.formInline1.keyWord = "";
      this.centerDialogVisible1 = false;
    },
    //选择销售人员
    surechoose(data) {
      this.form.salesman = data.realName;
      if (this.province.name) {
        this.signingStaff =
            this.province.name +
            this.form.company.companyName +
            this.form.salesman;
      } else {
        this.signingStaff = this.form.company.companyName + this.form.salesman;
      }

      this.centerDialogVisible = false;
      this.formInline.keyWord = "";
      this.count = this.count + 1;
    },
    //获取公司
    getCompanyList() {
      let id = "";
      if (this.inputprovince.id) {
        id = this.inputprovince.id;
      }
      if (this.province.id) {
        id = this.province.id;
      }
      let id1 = "";
      if (this.user.provincePrerm.includes(",")) {
        let arr = this.user.provincePrerm.split(",");
        if (arr[0] !== "") {
          id1 = arr[0];
        } else {
          id1 = arr[1];
        }
      } else {
        id1 = this.user.provincePrerm;
      }
      getCompanyList({level: 2, provinceId: id}).then((res) => {
        this.companyoptions = res.data || [];
        if (this.user.sysUserRole != 0 || id1 != "0") {
          this.form.company = {
            companyId: this.user.departmentId - 0,
            companyName: this.user.departmentName,
          };
        }
      });
    },
    pageuser(res) {
      let form = {
        departmentId:
            res === 5
                ? this.form.inputPersonCompany.companyId
                : this.form.company.companyId,
        departmentName:
            res === 5
                ? this.form.inputPersonCompany.companyName
                : this.form.company.companyName,
      };
      pageuser({
        department: form,
        keyWord: this.formInline.keyWord,
        current: 1,
        size: 1000
      }).then(
          (res) => {
            let data = res.data || {};
            this.gridData = data.records || [];
          }
      );
    },
    chooseuser() {
      if (this.istrue) {
        // this.pageuser();
        this.centerDialogVisible1 = true;
      }
    },
    chooseuser1() {
      let id = "";
      if (this.user.provincePrerm.includes(",")) {
        let arr = this.user.provincePrerm.split(",");
        if (arr[0] !== "") {
          id = arr[0];
        } else {
          id = arr[1];
        }
      } else {
        id = this.user.provincePrerm;
      }
      if (this.count == 0 || this.user.sysUserRole == 0 || id == "0") {
        // this.pageuser();
        this.centerDialogVisible = true;
      }
    },
    //获取在售商品
    getShoppProductPage() {
      this.product = {};
      getShoppProductPage({
        isShelf: 1,
        productType: this.form.productType,
        size: 500,
      }).then((res) => {
        let data = res.data || {};
        this.options = data.records || [];
      });
    },
  },
};
</script>

<style scoped lang="less">
.bigbox {
  padding: 30px;
}

/deep/ .input {
  width: 400px !important;
  margin-right: 10px !important;
}

/deep/ .el-select1 {
  width: 150px !important;
  margin-right: 10px !important;
}

.footer {
  display: flex;
  justify-content: center;
  margin-top: 80px;

  .button {
    margin-right: 300px;
  }
}
</style>
